import Vue from 'vue'
import { Button ,Select,Option,Carousel,CarouselItem} from 'element-ui'

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Carousel)
Vue.use(CarouselItem)
